
define('text!modules/strategy/templates/searchBoxGrid.html',[],function () { return '<div class="item {{^isActive}}inactive{{/isActive}} {{#isCurrent}}currentItem{{/isCurrent}}" data-id="{{id}}">\n    <div class="column strategy-name"><div class="truncate">{{name}}</div></div>\n    <div class="column spend-ydy">{{#asCurrency}}{{ydy}}{{/asCurrency}}</div>\n</div>';});

